import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/business',
    component: Layout,
    redirect: '/business/company',
    name: 'business',
    meta: {title: '业务管理'},
    children: [
      {
        path: 'company',
        name: 'company',
        component: () => import('@/views/LegalCompany/index'),
        meta: {title: '企业管理'}
      },
      {
        path: 'addupdateLegalCompany',
        name: 'addupdateLegalCompany',
        component: () => import('@/views/LegalCompany/companyAddUpdate'),
        meta: {title: '企业信息详情'},
        hidden: true
      },
      {
        path: 'legalCompanyPrincipal',
        name: 'legalCompanyPrincipal',
        component: () => import('@/views/LegalCompany/legalCompanyPrincipal'),
        meta: {title: '主要负责人及安全生产管理人员管理'},
        hidden: true
      },
      {
        path: 'legalCompanySpecialPersonnel',
        name: 'legalCompanySpecialPersonnel',
        component: () => import('@/views/LegalCompany/legalCompanySpecialPersonnel'),
        meta: {title: '特种设备作业人员、特种作业人员'},
        hidden: true
      },
      {
        path: 'legalCompanyStaff',
        name: 'legalCompanyStaff',
        component: () => import('@/views/LegalCompany/legalCompanyStaff'),
        meta: {title: '从业人员学历、工作年限层次结构'},
        hidden: true
      },
      {
        path: 'legalCompanyChemical',
        name: 'legalCompanyChemical',
        component: () => import('@/views/LegalCompany/legalCompanyChemical'),
        meta: {title: '危险化学品存放及生产使用情况'},
        hidden: true
      },
      {
        path: 'legalCompanyHazardSource',
        name: 'legalCompanyHazardSource',
        component: () => import('@/views/LegalCompany/legalCompanyHazardSource'),
        meta: {title: '重大危险源识别'},
        hidden: true
      },
      {
        path: 'legalCompanyEquipment',
        name: 'legalCompanyEquipment',
        component: () => import('@/views/LegalCompany/legalCompanyEquipment'),
        meta: {title: '主要设施、设备一览'},
        hidden: true
      },
      {
        path: 'legalCompanyEnvironment',
        name: 'legalCompanyEnvironment',
        component: () => import('@/views/LegalCompany/legalCompanyEnvironment'),
        meta: {title: '企业环境'},
        hidden: true
      },
      {
        path: 'legalCompanyBusinessLicens',
        name: 'legalCompanyBusinessLicens',
        component: () => import('@/views/LegalCompany/legalCompanyBusinessLicens'),
        meta: {title: '证照管理'},
        hidden: true
      },
      {
        path: 'legalCompanySecurityCertificate',
        name: 'legalCompanySecurityCertificate',
        component: () => import('@/views/LegalCompany/legalCompanySecurityCertificate'),
        meta: {title: '安全生产标准化达标证书'},
        hidden: true
      },
      {
        path: 'legalCompanyMeetingAttendance',
        name: 'legalCompanyMeetingAttendance',
        component: () => import('@/views/LegalCompany/legalCompanyMeetingAttendance'),
        meta: {title: '现场诊断会议签到表'},
        hidden: true
      },
      {
        path: 'legalCompanyRiskLevel',
        name: 'legalCompanyRiskLevel',
        component: () => import('@/views/LegalCompany/legalCompanyRiskLevel'),
        meta: {title: '风险等级'},
        hidden: true
      },
      {
        path: 'legalCompanyInspectionSituation',
        name: 'legalCompanyInspectionSituation',
        component: () => import('@/views/LegalCompany/legalCompanyInspectionSituation'),
        meta: {title: '企业生产行政许可'},
        hidden: true
      },
      {
        path: 'legalCompanySubjectResponsibility',
        name: 'legalCompanySubjectResponsibility',
        component: () => import('@/views/LegalCompany/legalCompanySubjectResponsibility'),
        meta: {title: '企业主体责任落实情况'},
        hidden: true
      },
      {
        path: 'legalCompanyAccidenty',
        name: 'legalCompanyAccidenty',
        component: () => import('@/views/LegalCompany/legalCompanyAccidenty'),
        meta: {title: '企业易发生事故类型'},
        hidden: true
      },
      {
        path: 'shop',
        name: 'shop',
        component: () => import('@/views/LegalShop/index'),
        meta: {title: '商铺管理'}
      },
      {
        path: 'addupdateLegalShop',
        name: 'addupdateLegalShop',
        component: () => import('@/views/LegalShop/addupdate'),
        meta: {title: '商铺信息详情'},
        hidden: true
      },
      {
        path: 'legalShopHidden',
        name: 'legalShopHidden',
        component: () => import('@/views/LegalShop/legalShopHidden'),
        meta: {title: '商铺隐患问题'},
        hidden: true
      },
      {
        path: 'legalShopBusinessLicense',
        name: 'legalShopBusinessLicense',
        component: () => import('@/views/LegalShop/legalShopBusinessLicense'),
        meta: {title: '证照管理'},
        hidden: true
      },
      {
        path: 'legalShopEnvironment',
        name: 'legalShopEnvironment',
        component: () => import('@/views/LegalShop/legalShopEnvironment'),
        meta: {title: '商铺环境'},
        hidden: true
      },
      {
        path: 'companyInspect',
        name: 'companyInspect',
        component: () => import('@/views/LegalCompanyInspect/index'),
        meta: {title: '企业巡查管理'}
      },
      {
        path: 'addupdateLegalCompanyInspect',
        name: 'addupdateLegalCompanyInspect',
        component: () => import('@/views/LegalCompanyInspect/addupdateLegalInspect'),
        meta: {title: '企业巡查详情'},
        hidden: true
      },
      {
        path: 'shopInspect',
        name: 'shopInspect',
        component: () => import('@/views/LegalShopInspect/index'),
        meta: {title: '商铺巡查管理'}
      },
      {
        path: 'addupdateLegalShopInspect',
        name: 'addupdateLegalShopInspect',
        component: () => import('@/views/LegalShopInspect/addupdateLegalShopInspect'),
        meta: {title: '商铺巡查详情'},
        hidden: true
      },
      {
        path: 'checkTheRecord',
        name: 'checkTheRecord',
        component: () => import('@/views/LegalCheckTheRecord/index'),
        meta: {title: '企业检查完毕记录'}
      },
      {
        path: 'addupdateLegalCheckTheRecord',
        name: 'addupdateLegalCheckTheRecord',
        component: () => import('@/views/LegalCheckTheRecord/addupdate'),
        meta: {title: '企业检查完毕记录详情'},
        hidden: true
      }, {
        path: 'shopCheckTheRecord',
        name: 'shopCheckTheRecord',
        component: () => import('@/views/LegalShopCheckTheRecord/index'),
        meta: {title: '商铺检查完毕记录'}
      },
      {
        path: 'addupdateLegalShopCheckTheRecord',
        name: 'addupdateLegalShopCheckTheRecord',
        component: () => import('@/views/LegalShopCheckTheRecord/addupdate'),
        meta: {title: '商铺检查完毕记录详情'},
        hidden: true
      },
      {
        path: 'legalCompanyDaily',
        name: 'legalCompanyDaily',
        component: () => import('@/views/LegalCompany/legalCompanyDaily'),
        meta: {title: '巡查日报'},
      },
      {
        path: 'comshop',
        name: 'DenseComShop',
        component: () => import('@/views/DenseComShop/index'),
        meta: {title: '人密管理'}
      },
      {
        path: 'denseInspect',
        name: 'denseInspect',
        component: () => import('@/views/DenseInspect/index'),
        meta: {title: '人密巡查管理'}
      },
      {
        path: 'addupdateDenseInspect',
        name: 'addupdateDenseInspect',
        component: () => import('@/views/DenseInspect/addupdateDenseInspect'),
        meta: {title: '人密巡查详情'},
        hidden: true
      },
    ]
  },
  {
    path: '/service',
    component: Layout,
    redirect: '/service/inspector',
    name: 'service',
    meta: {title: '服务管理'},
    children: [
      {
        path: 'inspector',
        name: 'inspector',
        component: () => import('@/views/LegalInspector/index'),
        meta: {title: '巡查人员管理'}
      }, {
        path: 'addupdateLegalInspector',
        name: 'addupdateLegalInspector',
        component: () => import('@/views/LegalInspector/addupdate'),
        meta: {title: '巡查人员详情'},
        hidden: true
      }, {
        path: 'newsCategory',
        name: 'newsCategory',
        component: () => import('@/views/LegalNewsCategory/index'),
        meta: {title: '通知类型管理'}
      }, {
        path: 'addupdateLegalNewsCategory',
        name: 'addupdateLegalNewsCategory',
        component: () => import('@/views/LegalNewsCategory/addupdate'),
        meta: {title: '通知类型详情'},
        hidden: true
      }, {
        path: 'news',
        name: 'news',
        component: () => import('@/views/LegalNews/index'),
        meta: {title: '通知管理'}
      }, {
        path: 'addupdateLegalNews',
        name: 'addupdateLegalNews',
        component: () => import('@/views/LegalNews/addupdate'),
        meta: {title: '通知详情'},
        hidden: true
      },
      {
        path: 'publishTbNews',
        name: 'publishTbNews',
        component: () => import('@/views/LegalNews/publishTbNews'),
        meta: {title: '发布通知'},
        hidden: true
      }, {
        path: 'LegalInspectorLogs',
        name: 'LegalInspectorLogs',
        component: () => import('@/views/LegalInspectorLogs/index'),
        meta: {title: '操作日志'}
      },
    ]
  },
  {
    path: '/platform',
    component: Layout,
    redirect: '/platform/legalLevel',
    name: 'platform',
    meta: {title: '平台维护'},
    children: [
      {
        path: 'legalLevel',
        name: 'legalLevel',
        component: () => import('@/views/LegalLevel/index'),
        meta: {title: '法律法规级别'}
      }, {
        path: 'addupdateLegalLevel',
        name: 'addupdateLegalLevel',
        component: () => import('@/views/LegalLevel/addupdate'),
        meta: {title: '法律法规级别详情'},
        hidden: true
      }, {
        path: 'legalCategory',
        name: 'legalCategory',
        component: () => import('@/views/LegalCategory/index'),
        meta: {title: '法律法规类别'}
      }, {
        path: 'addupdateLegalCategory',
        name: 'addupdateLegalCategory',
        component: () => import('@/views/LegalCategory/addupdate'),
        meta: {title: '法律法规类别详情'},
        hidden: true
      }, {
        path: 'legalFull',
        name: 'legalFull',
        component: () => import('@/views/LegalFull/index'),
        meta: {title: '法律法规全文'}
      }, {
        path: 'addupdateLegalFull',
        name: 'addupdateLegalFull',
        component: () => import('@/views/LegalFull/addupdate'),
        meta: {title: '法律法规全文详情'},
        hidden: true
      }, {
        path: 'legalEntry',
        name: 'legalEntry',
        component: () => import('@/views/LegalEntry/index'),
        meta: {title: '法律法规条目'}
      }, {
        path: 'addupdateLegalEntry',
        name: 'addupdateLegalEntry',
        component: () => import('@/views/LegalEntry/addupdate'),
        meta: {title: '法律法规条目详情'},
        hidden: true
      }, {
        path: 'legalKeyword',
        name: 'legalKeyword',
        component: () => import('@/views/LegalKeyword/index'),
        meta: {title: '关键词管理'}
      }, {
        path: 'legalKeywordEntry',
        name: 'legalKeywordEntry',
        component: () => import('@/views/LegalKeywordEntry/index'),
        meta: {title: '关键词管理详情'}
      }, {
        path: 'legalRectify',
        name: 'legalRectify',
        component: () => import('@/views/LegalRectify/index'),
        meta: {title: '整改措施'}
      }, {
        path: 'addupdateLegalRectify',
        name: 'addupdateLegalRectify',
        component: () => import('@/views/LegalRectify/addupdate'),
        meta: {title: '整改措施详情'},
        hidden: true
      },
      {
        path: 'searchInfo',
        name: 'searchInfo',
        component: () => import('@/views/SearchInfo/index'),
        meta: {title: '搜索信息'}
      }
    ]
  },
  {
    path: '/word',
    component: Layout,
    redirect: '/word/basis',
    name: 'word',
    meta: {title: '文档'},
    children: [
      , {
        path: 'basis',
        name: 'basis',
        component: () => import('@/views/Basis/index'),
        meta: {title: '依据'}
      }, {
        path: 'basisInfo',
        name: 'basisInfo',
        component: () => import('@/views/BasisInfo/index'),
        meta: {title: '依据详情'},
        hidden: true
      }, {
        path: 'conclusion',
        name: 'conclusion',
        component: () => import('@/views/LegalConclusion/index'),
        meta: {title: '结论管理'}
      }, {
        path: 'addupdateLegalConclusion',
        name: 'addupdateLegalConclusion',
        component: () => import('@/views/LegalConclusion/addupdate'),
        meta: {title: '结论管理详情'},
        hidden: true
      }, {
        path: 'statusSuggest',
        name: 'statusSuggest',
        component: () => import('@/views/LegalStatusSuggest/index'),
        meta: {title: '建议管理'}
      }, {
        path: 'addupdateLegalStatusSuggest',
        name: 'addupdateLegalStatusSuggest',
        component: () => import('@/views/LegalStatusSuggest/addupdate'),
        meta: {title: '建议管理详情'},
        hidden: true
      },
      // {
      //   path: 'currentSituation',
      //   name: 'currentSituation',
      //   component: () => import('@/views/CurrentSituation/index'),
      //   meta: {title: '现状管理'}
      // },
      {
        path: 'currentSituationInfo',
        name: 'currentSituationInfo',
        component: () => import('@/views/CurrentSituationInfo/index'),
        meta: {title: '现状管理'},
        hidden: true
      }, {
        path: 'hiddenProblem',
        name: 'hiddenProblem',
        component: () => import('@/views/LegalHiddenProblem/index'),
        meta: {title: '检查内容'}
      }, {
        path: 'addupdateLegalHiddenProblem',
        name: 'addupdateLegalHiddenProblem',
        component: () => import('@/views/LegalHiddenProblem/addupdate.vue'),
        meta: {title: '检查内容详情'},
        hidden: true
      }, {
        path: 'checkOpinion',
        name: 'checkOpinion',
        component: () => import('@/views/LegalShopCheckOpinion/index'),
        meta: {title: '检查意见'}
      }, {
        path: 'addupdateLegalShopCheckOpinion',
        name: 'addupdateLegalShopCheckOpinion',
        component: () => import('@/views/LegalShopCheckOpinion/addupdate.vue'),
        meta: {title: '检查意见详情'},
        hidden: true
      }, {
        path: 'shopRectify',
        name: 'shopRectify',
        component: () => import('@/views/LegalShopRectify/index'),
        meta: {title: '商铺存在问题'}
      }, {
        path: 'addupdateLegalShopRectify',
        name: 'addupdateLegalShopRectify',
        component: () => import('@/views/LegalShopRectify/addupdate'),
        meta: {title: '商铺存在问题详情'},
        hidden: true
      },
    ]
  },
  {
    path: '/platformSet',
    component: Layout,
    redirect: '/platformSet/companyIndustry',
    name: 'platformSet',
    meta: {title: '平台设置'},
    children: [
      {
        path: 'companyIndustry',
        name: 'companyIndustry',
        component: () => import('@/views/LegalCompanyIndustry/index'),
        meta: {title: '企业行业类别'}
      }, {
        path: 'addupdateLegalCompanyIndustry',
        name: 'addupdateLegalCompanyIndustry',
        component: () => import('@/views/LegalCompanyIndustry/addupdate'),
        meta: {title: '企业行业类别详情'},
        hidden: true
      }, {
        path: 'shopIndustry',
        name: 'shopIndustry',
        component: () => import('@/views/LegalShopIndustry/index'),
        meta: {title: '商铺行业类别'}
      }, {
        path: 'addupdateLegalShopIndustry',
        name: 'addupdateLegalShopIndustry',
        component: () => import('@/views/LegalShopIndustry/addupdate'),
        meta: {title: '商铺行业类别详情'},
        hidden: true
      }, {
        path: 'companyType',
        name: 'companyType',
        component: () => import('@/views/LegalCompanyType/index'),
        meta: {title: '企业类型'}
      }, {
        path: 'addupdateLegalCompanyType',
        name: 'addupdateLegalCompanyType',
        component: () => import('@/views/LegalCompanyType/addupdate'),
        meta: {title: '企业类型详情'},
        hidden: true
      }, {
        path: 'shopPlaceType',
        name: 'shopPlaceType',
        component: () => import('@/views/LegalShopPlaceType/index'),
        meta: {title: '商铺场所'}
      }, {
        path: 'addupdateLegalShopPlaceType',
        name: 'addupdateLegalShopPlaceType',
        component: () => import('@/views/LegalShopPlaceType/addupdate'),
        meta: {title: '商铺场所详情'},
        hidden: true
      }, {
        path: 'accident',
        name: 'accident',
        component: () => import('@/views/LegalAccident/index'),
        meta: {title: '事故类别列表'}
      },
      {
        path: 'addupdateLegalAccident',
        name: 'addupdateLegalAccident',
        component: () => import('@/views/LegalAccident/addupdate.vue'),
        meta: {title: '事故类别详情'},
        hidden: true
      },
      {
        path: 'certificate',
        name: 'certificate',
        component: () => import('@/views/LegalCertificate/index'),
        meta: {title: '证件类别列表'}
      },
      {
        path: 'addupdateLegalCertificate',
        name: 'addupdateLegalCertificate',
        component: () => import('@/views/LegalCertificate/addupdate.vue'),
        meta: {title: '证件类别详情'},
        hidden: true
      },
      {
        path: 'practicable',
        name: 'practicable',
        component: () => import('@/views/LegalPracticable/index'),
        meta: {title: '落实类别列表'}
      },
      {
        path: 'addupdateLegalPracticable',
        name: 'addupdateLegalPracticable',
        component: () => import('@/views/LegalPracticable/addupdate.vue'),
        meta: {title: '落实类别详情'},
        hidden: true
      }, {
        path: 'shopShowCategory',
        name: 'shopShowCategory',
        component: () => import('@/views/LegalShopShowCategory/index'),
        meta: {title: '街镇展示类别列表'}
      },
      {
        path: 'addupdateLegalShopShowCategory',
        name: 'addupdateLegalShopShowCategory',
        component: () => import('@/views/LegalShopShowCategory/addupdate.vue'),
        meta: {title: '街镇展示类别详情'},
        hidden: true
      }, {
        path: 'shopGasSupplyCompany',
        name: 'shopGasSupplyCompany',
        component: () => import('@/views/LegalShopGasSupplyCompany/index'),
        meta: {title: '燃气供气公司列表'}
      },
      {
        path: 'addupdateLegalShopGasSupplyCompany',
        name: 'addupdateLegalShopGasSupplyCompany',
        component: () => import('@/views/LegalShopGasSupplyCompany/addupdate.vue'),
        meta: {title: '燃气供气公司详情'},
        hidden: true
      },
    ]
  },
  {
    path: '/district',
    component: Layout,
    redirect: '/district/TbTown',
    name: 'district',
    meta: {title: '区域管理'},
    children: [
      {
        path: 'TbTown',
        name: 'TbTown',
        component: () => import('@/views/TbTown/index'),
        meta: {title: '乡镇管理'}
      },
      {
        path: 'addupdateTbTown',
        name: 'addupdateTbTown',
        component: () => import('@/views/TbTown/addupdateTbTown'),
        meta: {title: '乡镇详情'}
      },
      {
        path: 'TbStreet',
        name: 'TbStreet',
        component: () => import('@/views/TbStreet/index'),
        meta: {title: '居委管理'}
      },
      {
        path: 'addupdateTbStreet',
        name: 'addupdateTbStreet',
        component: () => import('@/views/TbStreet/addupdateTbStreet'),
        meta: {title: '居委详情'}
      },
      {
        path: 'TbLandmark',
        name: 'TbLandmark',
        component: () => import('@/views/TbLandmark/index'),
        meta: {title: '地标管理'}
      },
      {
        path: 'addupdateTbLandmark',
        name: 'addupdateTbLandmark',
        component: () => import('@/views/TbLandmark/addupdateTbLandmark'),
        meta: {title: '地标详情'}
      },

      {
        path: 'CJ',
        name: 'CJ',
        component: () => import('@/views/Commercial/cunJu'),
        meta: {title: '村居管理'}
      },

      {
        path: 'Commercial',
        name: 'Commercial',
        component: () => import('@/views/Commercial/index'),
        meta: {title: '商业体管理'}
      },
      {
        path: 'CommercialCJ',
        name: 'CommercialCJ',
        component: () => import('@/views/Commercial/commercialCunJu'),
        meta: {title: '商业体村居管理'}
      },
    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限管理'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
      {
        path: 'updatePassword',
        name: 'updatePassword',
        component: () => import('@/views/ums/updatePassword'),
        meta: {title: '修改密码'},
        hidden: true
      }
    ]
  },
  {
    path: '/bigScreen',
    component: Layout,
    redirect: '/bigScreen/cjVideo',
    name: 'bigScreen',
    meta: {title: '大屏数据'},
    children:[
      {
        path: 'cjVideo',
        name: 'cjVideo',
        component: () => import('@/views/bigScreen/cjVideo/index'),
        meta: {title: '村居鹰眼'}
      },
      {
        path: 'hxjg',
        name: 'hxjg',
        component: () => import('@/views/bigScreen/hxjg/index'),
        meta: {title: '重点监管'}
      },
      {
        path: 'addupdateHXJG',
        name: 'addupdateHXJG',
        component: () => import('@/views/bigScreen/hxjg/addUpdateHXJG'),
        meta: {title: '重点监管详情'},
        hidden: true
      },
      {
        path: 'agVideo',
        name: 'agVideo',
        component: () => import('@/views/bigScreen/agVideo/index'),
        meta: {title: '安管视频'}
      },
      {
        path: 'cqMerge',
        name: 'cqMerge',
        component: () => import('@/views/bigScreen/cqMerge/index'),
        meta: {title: '村企合并'}
      },
      {
        path: 'addupdateCQ',
        name: 'addupdateCQ',
        component: () => import('@/views/bigScreen/cqMerge/addupdateCQ'),
        meta: {title: '村企合并详情'},
        hidden: true
      },
      {
        path: 'zjgd',
        name: 'zjgd',
        component: () => import('@/views/bigScreen/zjgd/index'),
        meta: {title: '在建工地'}
      },
      {
        path: 'addupdateZjgd',
        name: 'addupdateZjgd',
        component: () => import('@/views/bigScreen/zjgd/addupdateZjgd'),
        meta: {title: '在建工地'}
      },
      {
        path: 'zzxq',
        name: 'zzxq',
        component: () => import('@/views/bigScreen/zzxq/index'),
        meta: {title: '住宅小区'}
      },
      {
        path: 'addupdateZzxq',
        name: 'addupdateZzxq',
        component: () => import('@/views/bigScreen/zzxq/addupdateZzxq'),
        meta: {title: '住宅小区'}
      },
      {
        path: 'zjf',
        name: 'zjf',
        component: () => import('@/views/bigScreen/zjf/index'),
        meta: {title: '自建房'}
      },
      {
        path: 'addupdateZjf',
        name: 'addupdateZjf',
        component: () => import('@/views/bigScreen/zjf/addupdateZjf'),
        meta: {title: '自建房'},

      },
      {
        path: 'zjfTown',
        name: 'zjfTown',
        component: () => import('@/views/bigScreen/zjfTown/index'),
        meta: {title: '自建房村居'}
      },
      {
        path: 'yanjie',
        name: 'yanjie',
        component: () => import('@/views/bigScreen/yanjie/index'),
        meta: {title: '沿街'}
      },
      {
        path: 'xfqy',
        name: 'xfqy',
        component: () => import('@/views/bigScreen/xfqy/index'),
        meta: {title: '消防重点企业'}
      },

      {
        path: 'addupdateXfqy',
        name: 'addupdateXfqy',
        component: () => import('@/views/bigScreen/xfqy/addupdateXfqy'),
        meta: {title: '自建房'},

      },
    ]
  },

  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  /**去掉url中的#*/
  mode: 'history',
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap.concat(asyncRouterMap)
})




// WEBPACK FOOTER //
// ./src/router/index.js